/* Local presentation only. Does not submit forms, access carts or make requests. */
(() => {
  if (!document.body.classList.contains('bc-theme') || window.Shopify?.designMode) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const selectors = [
    '.bc-section-heading', '.bc-benefits__heading', '.collection-hero__text-wrapper',
    '.product-card-wrapper', '.bc-benefit', '.bc-brand-panel__inner', '.bc-brand-panel__points > div',
    '.multicolumn-card', '.bc-contact-intro', '.contact__fields',
    '.footer-block', '.product__media-wrapper', '.bc-product-reviews',
    '.main-page-title', '.title--primary', '.article-template__title', '.blog__title',
    '.product__title', '.cart__footer', '.facets-container',
    '.customer > h1', '.customer form', '.cart-item', '.bc-product-description', '.bc-footer-contact__item',
    '.collapsible-content__heading', '.article-card-wrapper'
  ].join(',');
  let seen = new WeakSet();
  let observer;
  let ambient;
  const ambientSelectors = '.bc-benefits--playful, .bc-brand-panel--playful, .bc-trust-playful, .bc-faq-playful, .bc-hero, .footer, .product__inventory, .bc-contact-intro, .bc-shop-hero';
  function observeAccents(root = document) {
    if (!ambient || motion.matches) return;
    root.querySelectorAll(ambientSelectors).forEach(element => ambient.observe(element));
  }

  function observe(root = document) {
    if (motion.matches || !observer) return;
    root.querySelectorAll(selectors).forEach((element) => {
      // Dawn already animates its own scroll-trigger components.
      if (seen.has(element) || element.closest('.scroll-trigger, .bc-poster-slide, .shopify-app-block, bc-trust-loop, [data-trust-copy]') || element.parentElement.closest(selectors)) return;
      seen.add(element);
      const siblings = [...element.parentElement.children];
      const stagger = element.matches('.bc-benefit, .bc-brand-panel__points > div') ? 80 : 45;
      element.style.setProperty('--bc-motion-delay', `${Math.min(Math.max(siblings.indexOf(element), 0), 3) * stagger}ms`);
      observer.observe(element);
    });
  }

  function start() {
    if (motion.matches) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        // Keep headings at the viewport edge immediately readable.
        if (target.getBoundingClientRect().top > 40) target.classList.add('bc-motion-enter');
        observer.unobserve(target);
      });
    }, { threshold: 0.08 });
    if (document.body.classList.contains('bc-motion-rich')) {
      ambient = new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => target.classList.toggle('bc-motion-in-view', isIntersecting));
      }, { threshold: .05 });
      observeAccents();
    }
    observe();
  }

  motion.addEventListener('change', () => {
    observer?.disconnect();
    ambient?.disconnect();
    document.querySelectorAll('.bc-motion-in-view').forEach(element => element.classList.remove('bc-motion-in-view'));
    seen = new WeakSet();
    document.querySelectorAll('.bc-motion-enter').forEach((element) => {
      element.classList.remove('bc-motion-enter');
    });
    if (!motion.matches) start();
  });
  document.addEventListener('shopify:section:load', event => { observe(event.target); observeAccents(event.target); });
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('bc-motion-tab-hidden', document.hidden));
  start();
})();
